import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { SocialMediaUser } from '../../model/socialmedia-user';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface SocialMediaUsersState extends EntityState<SocialMediaUser> { }


@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'SocialMediaUser' })
export class SocialMediaUsersStore extends EntityStore<SocialMediaUsersState> {
  constructor() {
    super();
  }

  akitaPreUpdateEntity(_: SocialMediaUser, newEntity: SocialMediaUser) {
    return decodeEntity(newEntity);
  }

  akitaPreAddEntity(entity: SocialMediaUser) {
    return decodeEntity(entity);
  }

}

const decodeEntity = (entity: SocialMediaUser) => {
  entity.displayName = decodeFiwareString(entity.displayName?.value);
  entity.username = decodeFiwareString(entity.username?.value);
  entity.profileUrl = decodeFiwareString(entity.profileUrl?.value);

  return entity;
};
